import Config from "../config";

export const loggerMiddleware: any[] = [];

if (Config.DEBUG) {
  // tslint:disable-next-line:no-var-requires
  const { logger } = require("redux-logger");
  loggerMiddleware.push(logger);
}
